<template>
  <section>
    <!-- archived -->
    <div v-if="archived">
      <Alert
        :type="'warning'"
        :small="true"
        :text="this.insertString('ProductPage', 'ArchivedMessage')"
        :icon="true"
      />
    </div>
    <!-- VIEW BAG... -->
    <div
      v-else-if="productReleased || sellSkisBeforeAvailable"
      class="product-shopblock-actions d-flex flex-wrap justify-content-between"
    >
      <ConfigurationProducts
        class="config-module p-t-6"
        ref="configproduct"
        v-if="showConfiguration"
        :code="configurationProducts[0]"
        :showError="cnfProducts.showError"
        @on-adding-to-bag="mixin_addToBag_adding = true"
        @on-no-inventory="cnfProducts.visible = false"
      />
      <div v-else-if="showUlysseComment" class="m-b-18">
        <InputFieldV2
          v-model="ulysse.size"
          id="ulyssesize"
          class="m-b-18"
          :label="insertString('ProductPage', 'UlysseSize')"
          :block="true"
        />
        <InputFieldV2
          v-model="ulysse.comment"
          id="ulyssecomment"
          :label="insertString('ProductPage', 'UlysseComment')"
          :block="true"
        />
      </div>
      <div class="add-to-bag m-t-12" style="min-width: calc(50% - 9px)">
        <!-- ADD TO BAG BUTTON -->
        <ButtonComponent

          id="addToBagButton"
          :text="insertString('Product', 'Add')"
          :block="true"
          :ghost="allSizesOutOfStock"
          :overrideThemeColor="Globals.colors.blueDark"
          :loading="mixin_addToBag_adding"
          :loadingText="insertString('Product', 'Adding')"
          :disabled="addToBagButtonDisabledText !== ''"
          :disabledText="addToBagButtonDisabledText"
          :disabledShake="true"
          @click="addToBagValidate"
        />
        <div class="msg -small-text m-t-9">{{ webInventoryMessage }}</div>
      </div>
      <!-- RESERVE IN STORE BUTTON -->
      <div
        v-if="showStoreButton"
        style="min-width: calc(50% - 9px)"
        class="m-t-12"
      >
        <ButtonComponent
          id="reserveInStoreButton"
           :text="insertString('Product', 'ClickAndCollect')"
          :block="true"
          theme="main"
          :ghost="!allSizesOutOfStock"
          :overrideThemeColor="Globals.colors.blueDark"
          :disabled="storeButtonDisabled"
          :disabledText="insertString('Product', 'SelectSize')"
          :disabledShake="true"
          :primary="addToBagButtonDisabledText !== '' && !storeButtonDisabled"
          @click="reserveInStore()"
        />
        <div class="msg -small-text m-t-9" v-html="storeInventoryMessage" />
      </div>
    </div>
    <!-- ...OR NOT IN STOCK -->
    <div v-else class="product-shopblock-notify m-b-18">
      <!-- PRE PURCHASE BUTTON -->
      <ButtonComponent
        v-if="isPrePurchase"
        :overrideThemeColor="Globals.colors.blueDark"
        :disabledShake="true"
        theme="main"
        :block="true"
        @click="showPrePurchaseConfirm = true"
        :text="insertString('Product', 'PreOrderButton')"
      />
      <!-- NOTIFY BUTTON-->
      <ButtonComponent
        v-if="isPrePurchase"
        :overrideThemeColor="Globals.colors.blueDark"
        :disabledShake="true"
        theme="main"
        :block="true"
        :ghost="true"
        @click="showNotifyConfirm = true"
        :text="insertString('Product', 'GetNotified')"
      />
      <!-- open notify in modal if prepurchase (notify button visible) -->
      <Modal
        @close="showNotifyConfirm = false"
        :visible="showNotifyConfirm"
        :title="insertString('Product', 'GetNotified')"
        :gridCols="4"
        :compact="true"
      >
        <Notify
          class="m-t-18 m-b-18"
          :model="model"
          :currentVariant="currentVariant"
          :availableFrom="availableFrom"
        />
      </Modal>

      <div v-if="isPrePurchase">
        <PrePurchaseNote class="m-t-18" :availableFrom="availableFrom" />
        <PrePurchaseConfirm
          :model="model"
          :sku="sku"
          :currentVariant="currentVariant"
          :visible="showPrePurchaseConfirm"
          @close="showPrePurchaseConfirm = false"
        />
      </div>
    </div>

    <Notify
      class="m-t-18 m-t-md-0"
      v-if="!prePurchaseAvailableCountry.fetching && activateNotifyForm"
      :model="model"
      :currentVariant="currentVariant"
      :selectedSizeObject="selectedSizeObject"
      :availableFrom="availableFrom"
    />

    <ReserveInStore
      :storeInventoryData="storeInventoryData ? storeInventoryData[sku] : []"
      :code="code"
      :sku="sku"
      :productModel="model"
      :currentVariant="currentVariant"
      :visible="showReserveInStoreModal"
      @close="closeReserveInStore"
    />
  </section>
</template>
<script>
import { mapState } from 'vuex';
import Api from '@/Scripts/api/api';
import addToBagMixin from '@/Scripts/lib/mixins/addToBagmixin.js';
import ButtonComponent from '@/Scripts/components/shared/ButtonV2/ButtonV2.vue';
import { ProductSortSizes } from '@/Scripts/lib/helper/productHelper.js';
import Modal from '@/Scripts/components/shared/Modal/ModalNew.vue';
import { ProductIsAvailable, ProductIsAvailableInFuture } from '@/Scripts/lib/helper/dateHelper.js';
import { PRODUCTCODES } from '@/Scripts/constants.js';
import cartHelper from '@/Scripts/lib/helper/cartHelper';
const PrePurchaseConfirm = () => import('@/Scripts/components/shared/PrePurchase/PrePurchaseConfirm.vue');
const PrePurchaseNote = () => import('@/Scripts/components/shared/PrePurchase/PrePurchaseNote.vue');
const Notify = () => import(/* webpackChunkName: "Notify" */'@/Scripts/components/pages/ProductV2/Blocks/BlockAssets/Notify.vue');
const ReserveInStore = () => import('@/Scripts/components/pages/ProductV2/ReserveInStore/ReserveInStore.vue');
const Alert = () => import(/* webpackChunkName: "Alert" */'@/Scripts/components/shared/Alert/Alert.vue');
const ConfigurationProducts = () => import('@/Scripts/components/pages/ProductV2/Blocks/ShopBlockAssets/ConfigurationProducts/ConfigurationProducts.vue');
const InputFieldV2 = () => import('@/Scripts/components/shared/InputFieldV2/InputFieldV2.vue');

export default {
  mixins: [addToBagMixin],
  components: {
    ButtonComponent,
    Modal,
    PrePurchaseConfirm,
    PrePurchaseNote,
    Notify,
    ReserveInStore,
    Alert,
    ConfigurationProducts,
    InputFieldV2

  },
  props: {
    model: Object,
    currentVariant: Object,
    sizeVariantIndex: Number,
    outlet: Boolean,
    archived: Boolean,
    availibleInFuture: Boolean,
    oneSize: Boolean,
    configurationProducts: Array,
    hideColorAndSize: Boolean
  },
  data () {
    return {
      defaultMinimumInventory: 1,
      outletMinimumInventory: 1,
      showNotifyConfirm: false,
      storeInventoryData: null,
      showReserveInStoreModal: false,
      sizeWarning: false,
      storeButtonDisabled: false,
      showPrePurchaseConfirm: false,
      prePurchaseAvailableCountry: {
        fetching: false,
        available: false
      },
      cnfProducts: {
        code: null,
        visible: false
      },
      ulysse: {
        size: '',
        comment: ''
      },
      sellSkisBeforeAvailable: false
    };
  },
  watch: {
    sku (val) {
      if (val && this.storeButtonDisabled) {
        this.storeButtonDisabled = false;
      }
      if (val && this.sizeWarning) {
        this.sizeWarning = false;
      }
    }
  },
  computed: {
    ...mapState({
      PrePurchaseAvailableIn: state => state.siteInfo.features.PrePurchaseAvailableIn,
      currentCountry: state => state.siteInfo.currentCountry
      // user: state => state.userInformation
    }),
    minimumInventory () {
      if (this.outlet) {
        return this.outletMinimumInventory;
      }
      return this.defaultMinimumInventory;
    },
    showConfiguration () {
      return this.cnfProducts.visible;
    },
    showUlysseComment () {
      return this.code === PRODUCTCODES.ULYSSE;
    },
    code () {
      return this.model.Code;
    },
    availableFrom () {
      return this.model.AvailableFrom;
    },
    productReleased () {
      if (!this.availableFrom) {
        return true;
      }
      return this.outlet || ProductIsAvailable(this.availableFrom);
    },
    showStoreButton () {
      return !this.outlet && !this.hideColorAndSize && !this.model.IsClickAndCollectDisabled;
    },
    currentVariantSizes () {
      if (this.currentVariant) {
        return ProductSortSizes(this.currentVariant.SizeVariations);
      }
      return [];
    },
    selectedSizeObject () {
      if (this.sizeVariantIndex === -1) {
        return null;
      }
      return this.currentVariantSizes[this.sizeVariantIndex];
    },
    sku () {
      if (!this.selectedSizeObject) {
        return null;
      }
      return this.selectedSizeObject.Sku;
    },
    storeInventoryMessage () {
      if (this.hasStoreInventory) {
        if (this.selectedSizeObject) {
          return this.replaceAndInsert(
            'count',
            this.productStoreInventoryCount,
            'ProductPage',
            'AvailabilityInStoreWithCount'
          );
        } else {
          return '&nbsp;';
        }
      }
      return '&nbsp;';
    },
    isPrePurchase () {
      return this.model.PrePurchase && this.prePurchaseAvailableCountry.available;
    },
    hasStoreInventory () {
      return this.storeInventoryData && Object.keys(this.storeInventoryData).length > 0;
    },
    productStoreInventoryCount () {
      if (this.storeInventoryData && this.sku) {
        if (this.oneSize) {
          const skusplit = this.sku.split(' ');
          const keys = Object.keys(this.storeInventoryData).filter(key => key.includes(skusplit[1]));
          return keys.length ? this.storeInventoryData[keys[0]].length : 0;
        }
        if (!this.storeInventoryData[this.sku]) {
          return 0;
        }
        return this.storeInventoryData[this.sku].length;
      }
      return 0;
    },
    webInventory () {
      if (this.sku) {
        return this.selectedSizeObject.Inventory;
      }
      return null;
    },
    allSizesOutOfStock () {
      if (this.currentVariant) {
        return this.currentVariant.SizeVariations.filter(obj => obj.Inventory > 0).length === 0;
      }
      return false;
    },
    webInventoryMessage () {
      if (this.webInventory !== null) {
        if (this.webInventory >= 5) {
          return this.insertString('Product', 'InStock');
        } else if (this.webInventory >= this.minimumInventory) {
          return this.replaceAndInsert('items', this.webInventory, 'Product', 'FewLeft');
        } else {
          let date = this.selectedSizeObject && this.selectedSizeObject.ExpectedRestockDate ? this.selectedSizeObject.ExpectedRestockDate : this.availibleInFuture ? this.model.AvailableFrom : null;
          if (date) {
            const options = { year: 'numeric', month: 'short', day: 'numeric' };
            const lang = document.getElementsByTagName('html')[0].getAttribute('lang');
            date = new Date(date).toLocaleDateString(lang, options);
            return this.replaceAndInsert('date', date, 'Product', 'ComingBackLater');
          }
          return '';
        }
      }
      return '';
    },
    addToBagButtonDisabledText () {
      if (((this.webInventory !== null && this.webInventory < this.minimumInventory) || this.allSizesOutOfStock || !this.productReleased) && !this.sellSkisBeforeAvailable) {
        return this.insertString('Product', 'OutOfStock');
      }
      if (this.sizeWarning) {
        return this.insertString('Product', 'SelectSize');
      }
      return '';
    },
    activateNotifyForm () {
      return !this.archived &&
             !this.outlet &&
            (this.allSizesOutOfStock || ProductIsAvailableInFuture(this.model.AvailableFrom) || (this.selectedSizeObject && this.selectedSizeObject.Inventory === 0 && ProductIsAvailableInFuture(this.selectedSizeObject.ExpectedRestockDate)));
    }

  },
  methods: {
    closeReserveInStore () {
      this.showReserveInStoreModal = false;
      setTimeout(() => {
        document.getElementById('reserveInStoreButton').focus();
      }, 330);
    },
    addToBagValidate () {
      this.sizeWarning = this.sku === null;
      if (!this.cnfProducts.visible && !this.showUlysseComment) {
        // regular add to bag
        if (this.webInventory && this.webInventory > 0) {
          this.mixin_addToBag_add('product_page_add', this.currentVariant, this.selectedSizeObject);
        }
      } else if (this.cnfProducts.visible) {
        // with config-products add to bag
        if (!this.sizeWarning) {
          this.$refs.configproduct.addToBag('product_page_add', this.selectedSizeObject.Sku);
        }
      } else if (this.showUlysseComment) {
        this.mixin_addToBag_adding = true;
        cartHelper.addUlyssePackage(this.sku, null, false, this.ulysse.size, this.ulysse.comment, '').then(response => {
          this.$store.dispatch('bag/getCartItems');
        });
      }
    },
    reserveInStore () {
      if (this.sku) {
        this.showReserveInStoreModal = true;
      } else {
        this.storeButtonDisabled = true;
      }
    },
    checkSellSkisFeatureSwitch () {
      Api.getContentByFriendlyUrl('api/feature/SellSkisBeforeAvailable')
        .then(response => {
          this.sellSkisBeforeAvailable = response.data === true;
        })
        .catch();
    }
  },
  async created () {
    // reserve in store availiblility
    try {
      const response = await Api.getContentByFriendlyUrl(`/api/product/ProductStoreAvailability?code=${this.code}`);
      this.storeInventoryData = response.data;
    } catch (e) {
      console.log(e);
    }

    // prepurhcase availibility
    if (this.model.PrePurchase) {
      try {
        this.prePurchaseAvailableCountry.fetching = true;
        const response = await Api.getContentByFriendlyUrl('/api/product/PrePurchaseAvailable');
        this.prePurchaseAvailableCountry.available = response.data;
        this.prePurchaseAvailableCountry.fetching = false;
      } catch (e) {
        this.prePurchaseAvailableCountry.fetching = false;
        console.log(e);
      }
    }

    // View configuration products
    if (this.configurationProducts && this.configurationProducts.length) {
      this.checkSellSkisFeatureSwitch();
      this.cnfProducts.visible = true;
      this.cnfProducts.code = this.configurationProducts[0];
    }
  }

};
</script>
